import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex items-center justify-center p-8">
      <div className="max-w-md w-full border border-border bg-card p-10 text-center">
        <XCircle size={40} weight="fill" className="mx-auto text-muted-foreground" />
        <h1 className="font-serif-display text-3xl mt-6">Payment cancelled.</h1>
        <p className="text-sm text-muted-foreground mt-2">
          You can retry from the invoice at any time.
        </p>
        <Link
          to="/invoices"
          className="inline-block mt-8 rounded-sm border border-border px-6 py-2 text-xs uppercase tracking-widest font-mono hover:bg-muted transition-colors duration-200"
        >
          Back to Invoices
        </Link>
      </div>
    </div>
  );
}
